module.exports = __webpack_public_path__ + "static/img/21.ce66117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/21.png
// module id = 8Nql
// module chunks = 0